import { post, patch, get, destroy } from './httpClient'

export const getEmailManager = (query) => get('/email-manager', query)
export const addEmailManager = (body) => post('/email-manager/create', body)
export const updateEmailManager = (id, body) => patch(`/email-manager/update/${id}`, body)
export const deleteEmailManagerer = (id) => destroy(`/email-manager/delete/${id}`)
